/* ELLE EXISTE · EE Icons story section */
(function () {
  if (customElements.get('ee-icons-app')) return;

  class EEIcons extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const tpl = this.querySelector('template');
      const dEl = this.querySelector('script[data-ee="i18n"]');
      const aEl = this.querySelector('script[data-ee="i18n-all"]');
      const rEl = this.querySelector('script[data-ee="reviews"]');
      let D = {}, REV = [];
      if (aEl) {
        let ALL = {}; try { ALL = JSON.parse(aEl.textContent); } catch (e) {}
        const ok = l => l && ALL[l];
        let l = null;
        try { l = new URLSearchParams(location.search).get('ee_lang'); } catch (e) {}
        if (!ok(l)) { try { l = localStorage.getItem('ee_lang'); } catch (e) { l = null; } }
        if (!ok(l)) { l = ((navigator.languages || [navigator.language || 'en'])).map(x => String(x).toLowerCase().split('-')[0]).find(x => ALL[x]) || 'en'; }
        try { localStorage.setItem('ee_lang', l); } catch (e) {}
        this.dataset.lang = l; D = ALL[l] || ALL.en || {};
        loadFonts(l);
      } else {
        try { D = JSON.parse(dEl.textContent); } catch (e) {}
      }
      try { REV = JSON.parse(rEl.textContent); } catch (e) {}
      const frag = tpl.content.cloneNode(true);
      frag.querySelectorAll('[data-i18n]').forEach(el => { const v = D[el.dataset.i18n]; if (v != null) el.innerHTML = v; });
      frag.querySelectorAll('[data-i18n-aria]').forEach(el => { const v = D[el.dataset.i18nAria]; if (v != null) el.setAttribute('aria-label', v); });
      frag.querySelectorAll('[data-i18n-next]').forEach(el => { const v = D[el.dataset.i18nNext]; if (v != null) el.dataset.next = v; });
      const root = this.shadowRoot || this.attachShadow({ mode: 'open' });
      root.appendChild(frag);
      const wrap = root.querySelector('.ee-root');
      wrap.setAttribute('dir', D.dir || 'ltr');
      wrap.setAttribute('lang', this.dataset.lang || 'en');
      run(root, D, REV, this.dataset);
    }
  }
  customElements.define('ee-icons-app', EEIcons);

  function loadFonts(l) {
    const F = { ar: 'Noto+Naskh+Arabic:wght@500;600&family=Noto+Sans+Arabic:wght@400;500;600', zh: 'Noto+Serif+SC:wght@500;600&family=Noto+Sans+SC:wght@400;500', ja: 'Noto+Serif+JP:wght@500;600&family=Noto+Sans+JP:wght@400;500', ko: 'Noto+Serif+KR:wght@500;600&family=Noto+Sans+KR:wght@400;500' };
    if (!F[l] || document.getElementById('ee-font-' + l)) return;
    const k = document.createElement('link'); k.id = 'ee-font-' + l; k.rel = 'stylesheet';
    k.href = 'https://fonts.googleapis.com/css2?family=' + F[l] + '&display=swap'; document.head.appendChild(k);
  }

  function run(R, D, REV, cfg) {
    const $ = id => R.getElementById(id);
    const A = n => (cfg.assets || '') + n;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const feed = $('feed'), cards = [...feed.querySelectorAll('.card')], segs = $('segs'), ct = $('ct');
    const N = cards.length, pad = n => String(n).padStart(2, '0');

    cards.forEach((c, i) => {
      segs.insertAdjacentHTML('beforeend', '<i><b></b></i>');
      const b = document.createElement('button'); b.className = 'next';
      const sp = document.createElement('span'); sp.textContent = c.dataset.next || '';
      b.appendChild(sp);
      b.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24">' + (c.dataset.last ? '<path d="M4 12a8 8 0 1 0 3-6.3M4 4v4h4"/>' : '<path d="M6 9l6 6 6-6"/>') + '</svg>');
      b.addEventListener('click', () => { const t = c.dataset.last ? cards[0] : cards[i + 1]; feed.scrollTo({ top: t.offsetTop, behavior: 'smooth' }); });
      c.appendChild(b);
    });
    const bars = [...segs.children];
    function setActive(i) {
      bars.forEach((s, k) => s.classList.toggle('on', k <= i));
      $('phone').classList.toggle('oncover', i === 0);
      ct.textContent = pad(i + 1) + '/' + pad(N);
      cards.forEach((c, k) => { if (k === i && !c.classList.contains('play')) c.classList.add('play'); if (k !== i) c.classList.remove('play'); });
    }
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting && e.intersectionRatio > .6) setActive(cards.indexOf(e.target)); }), { root: feed, threshold: [.6] });
      cards.forEach(c => io.observe(c));
    }
    feed.scrollTop = 0;
    setActive(0);
    feed.tabIndex = 0;
    feed.addEventListener('keydown', e => {
      const i = Math.round(feed.scrollTop / feed.clientHeight);
      if (e.key === 'ArrowDown' || e.key === 'PageDown') { e.preventDefault(); feed.scrollTo({ top: cards[Math.min(N - 1, i + 1)].offsetTop, behavior: 'smooth' }); }
      if (e.key === 'ArrowUp' || e.key === 'PageUp') { e.preventDefault(); feed.scrollTo({ top: cards[Math.max(0, i - 1)].offsetTop, behavior: 'smooth' }); }
    });

    /* symbol chips (Her / Him) */
    const tplEl = $('symTpl');
    const parts = (D.c2_tpl || 'This is my symbol of {x}').split('{x}');
    tplEl.innerHTML = '';
    tplEl.append(document.createTextNode(parts[0] || ''));
    const sym = document.createElement('u'); sym.id = 'sym'; tplEl.append(sym);
    if (parts[1]) tplEl.append(document.createTextNode(parts[1]));
    const CH = { her: D.chips_her || [], him: D.chips_him || [] };
    const chipBox = $('chips'), symTabs = [...R.querySelectorAll('#symTabs button')];
    let chipAuto = true, ci = 0, side = 'her', chipEls = [];
    function pick(b) { chipEls.forEach(x => x.setAttribute('aria-pressed', x === b)); sym.textContent = b.textContent; sym.classList.remove('flip'); void sym.offsetWidth; sym.classList.add('flip'); }
    function build(k) {
      side = k; ci = 0; symTabs.forEach(t => t.setAttribute('aria-selected', t.dataset.k === k));
      chipBox.innerHTML = '';
      CH[k].forEach((t, i) => { const b = document.createElement('button'); b.className = 'chip'; b.setAttribute('aria-pressed', i === 0); b.textContent = t; chipBox.appendChild(b); });
      chipEls = [...chipBox.children]; if (chipEls[0]) pick(chipEls[0]);
    }
    symTabs.forEach(t => t.addEventListener('click', () => { chipAuto = false; build(t.dataset.k); }));
    chipBox.addEventListener('click', e => { const b = e.target.closest('.chip'); if (!b) return; chipAuto = false; pick(b); });
    build('her');
    setInterval(() => { const c = chipBox.closest('.card'); if (!chipAuto || !c.classList.contains('play') || reduce) return; ci++; if (ci >= chipEls.length) { build(side === 'her' ? 'him' : 'her'); return; } pick(chipEls[ci]); }, 1900);

    /* coverflow 3D */
    const flow = $('flow'), figs = [...flow.children];
    function cf() {
      const r = flow.getBoundingClientRect(), mid = r.left + r.width / 2;
      figs.forEach(f => { const fr = f.getBoundingClientRect(), d = (fr.left + fr.width / 2 - mid) / fr.width, c = Math.max(-1.5, Math.min(1.5, d));
        f.style.transform = 'rotateY(' + (-c * 38) + 'deg) translateZ(' + (-Math.abs(c) * 90) + 'px) scale(' + (1 - Math.abs(c) * .06) + ')'; f.style.zIndex = 10 - Math.round(Math.abs(c) * 3); });
    }
    flow.addEventListener('scroll', () => requestAnimationFrame(cf), { passive: true });
    window.addEventListener('resize', cf);
    requestAnimationFrame(() => { flow.scrollLeft = (figs[1].offsetLeft + figs[1].offsetWidth / 2) - flow.clientWidth / 2; cf(); });

    /* reviews */
    const note = $('revNote');
    note.innerHTML = (D.c7_note || '').replace('{link}', '<a href="https://www.trustpilot.com/review/ellexist.com" target="_blank" rel="noopener">Trustpilot ↗</a>');
    const revs = $('revs'), rc = $('rcount'); let filt = 'all', auto = true;
    function draw() {
      revs.innerHTML = '';
      REV.filter(r => filt === 'all' || (filt === 'icon' && r.i) || (filt === 'low' && r.s < 5)).forEach(r => {
        const a = document.createElement('article'); a.className = 'rv' + (r.s < 5 ? ' low' : ''); a.tabIndex = 0; a.lang = 'en'; a.dir = 'ltr';
        const top = document.createElement('div'); top.className = 'top';
        const st = document.createElement('span'); st.className = 'st'; st.textContent = '★'.repeat(r.s) + '☆'.repeat(5 - r.s); st.setAttribute('aria-label', r.s + ' ' + (D.stars || 'stars')); top.appendChild(st);
        if (r.i) { const ic = document.createElement('span'); ic.className = 'ic'; ic.textContent = D.icon_badge || 'Icon'; top.appendChild(ic); }
        const p = document.createElement('p'); p.textContent = r.t;
        const w = document.createElement('div'); w.className = 'who'; w.textContent = r.n + ' · ' + r.c + ' · ' + r.d;
        a.append(top, p, w); a.addEventListener('click', () => { a.classList.toggle('open'); auto = false; }); revs.appendChild(a);
      });
      revs.scrollLeft = 0; count();
    }
    function count() { const cs = revs.children; if (!cs.length) { rc.textContent = ''; return; } const i = Math.round(revs.scrollLeft / (cs[0].offsetWidth + 12)); rc.textContent = Math.min(cs.length, i + 1) + ' / ' + cs.length; }
    revs.addEventListener('scroll', () => requestAnimationFrame(count), { passive: true });
    ['pointerdown', 'touchstart', 'wheel'].forEach(ev => revs.addEventListener(ev, () => auto = false, { passive: true }));
    $('pills').addEventListener('click', e => { const b = e.target.closest('.pill'); if (!b) return; filt = b.dataset.f; R.querySelectorAll('.pill').forEach(x => x.setAttribute('aria-pressed', x === b)); draw(); });
    draw();
    const revCard = revs.closest('.card');
    setInterval(() => { if (!auto || reduce || !revCard.classList.contains('play')) return; const w = revs.children[0] ? revs.children[0].offsetWidth + 12 : 0;
      if (revs.scrollLeft + revs.clientWidth >= revs.scrollWidth - 4) revs.scrollTo({ left: 0, behavior: 'smooth' }); else revs.scrollBy({ left: w, behavior: 'smooth' }); }, 3200);
    const sc = $('score');
    new MutationObserver(() => { if (revCard.classList.contains('play') && !reduce) { let t0 = null; const f = t => { t0 = t0 || t; const k = Math.min(1, (t - t0) / 1100); sc.textContent = (4.7 * k).toFixed(1); if (k < 1) requestAnimationFrame(f); }; requestAnimationFrame(f); } }).observe(revCard, { attributes: true, attributeFilter: ['class'] });

    /* packing video */
    const vid = R.querySelector('video.vid');
    if (vid) {
      const vCard = vid.closest('.card');
      vid.muted = true; vid.defaultMuted = true; vid.playsInline = true; vid.loop = true; vid.controls = false; vid.setAttribute('webkit-playsinline', '');
      const pb = document.createElement('button'); pb.className = 'vplay'; pb.setAttribute('aria-label', D.play || 'Play'); pb.innerHTML = '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>'; pb.hidden = true; vCard.appendChild(pb);
      const tryPlay = () => { const pr = vid.play(); if (pr && pr.then) pr.then(() => { pb.hidden = true; }).catch(() => { pb.hidden = false; }); };
      pb.addEventListener('click', e => { e.stopPropagation(); tryPlay(); });
      vid.addEventListener('playing', () => { pb.hidden = true; });
      ['touchstart', 'click'].forEach(ev => R.addEventListener(ev, () => { if (vCard.classList.contains('play') && vid.paused) tryPlay(); }, { passive: true }));
      new MutationObserver(() => { if (vCard.classList.contains('play')) tryPlay(); else vid.pause(); }).observe(vCard, { attributes: true, attributeFilter: ['class'] });
    }

    /* find your symbol tabs */
    const L = D.sy || [];
    const SY = [
      { img: 'ee-sy-her.jpg', p: [['ee-pr-ren.jpg', 'Renaissance Romance'], ['ee-pr-hoop.jpg', 'Glimmering Hoop'], ['ee-pr-twisted.jpg', 'Twisted Radiance']] },
      { img: 'ee-sy-journey.jpg', p: [['ee-pr-keylia.jpg', 'Keylia'], ['ee-pr-starry.jpg', 'Starry Heart']] },
      { img: 'ee-sy-him.jpg', p: [['ee-pr-bold.jpg', 'Bold Elegance'], ['ee-pr-gilded.jpg', 'Gilded Link'], ['ee-pr-rebel.jpg', 'Rebel Spirit']] },
      { img: 'ee-sy-mom.jpg', p: [['ee-pr-pure.jpg', 'Pure Mama'], ['ee-pr-golden.jpg', 'Golden Mama'], ['ee-pr-radiant.jpg', 'Radiant Mom']] },
      { img: 'ee-sy-pets.jpg', p: [['ee-pr-argos.jpg', 'Argos'], ['ee-pr-hachi.jpg', 'Hachi'], ['ee-pr-loulou.jpg', 'Loulou']] }
    ];
    const tabs = [...R.querySelectorAll('#tabs button')], symImg = $('symImg'), symLine = $('symLine'), prods = $('prods');
    const search = cfg.search || '/search';
    let ti = 0, tabAuto = true;
    function showTab(i, anim) {
      ti = i; const d = SY[i]; tabs.forEach((b, k) => b.setAttribute('aria-selected', k === i));
      symImg.src = A(d.img); symImg.alt = d.p[0][1]; symLine.innerHTML = L[i] || '';
      prods.innerHTML = '';
      d.p.forEach(x => {
        const a = document.createElement('a'); a.href = search + '?q=' + encodeURIComponent(x[1]);
        const im = document.createElement('img'); im.src = A(x[0]); im.alt = x[1]; im.loading = 'lazy';
        const s = document.createElement('span'); s.textContent = x[1];
        const em = document.createElement('em'); em.textContent = D.shop || 'Shop ↗';
        a.append(im, s, em); prods.appendChild(a);
      });
      if (anim) [symImg, symLine, prods].forEach(el => { el.classList.remove('turn'); void el.offsetWidth; el.classList.add('turn'); });
    }
    tabs.forEach((b, k) => b.addEventListener('click', () => { tabAuto = false; showTab(k, true); }));
    showTab(0, false);
    SY.forEach(d => { const i = new Image(); i.src = A(d.img); });
    const tabCard = symImg.closest('.card');
    setInterval(() => { if (!tabAuto || !tabCard.classList.contains('play') || reduce) return; showTab((ti + 1) % SY.length, true); }, 3600);

    /* language sheet */
    const lb = $('langBtn'), ls = $('langSheet');
    if (lb && ls) {
      const cur = (cfg.lang || 'en');
      const lc = $('langCode'); if (lc) lc.textContent = cur.toUpperCase();
      ls.querySelectorAll('[data-setlang]').forEach(b => {
        if (b.dataset.setlang === cur) b.classList.add('on');
        b.addEventListener('click', () => {
          const l = b.dataset.setlang; try { localStorage.setItem('ee_lang', l); } catch (e) {}
          try { const u = new URL(location.href); u.searchParams.set('ee_lang', l); location.href = u.toString(); } catch (e) { location.reload(); }
        });
      });
      lb.addEventListener('click', e => { e.stopPropagation(); ls.hidden = false; });
      ls.addEventListener('click', e => { if (e.target === ls) ls.hidden = true; });
      R.addEventListener('keydown', e => { if (e.key === 'Escape') ls.hidden = true; });
    }

    /* rail */
    const toast = $('toast'); let tt;
    const say = m => { toast.textContent = m; toast.hidden = false; clearTimeout(tt); tt = setTimeout(() => toast.hidden = true, 1600); };
    const like = $('like'); like.addEventListener('click', () => { like.classList.toggle('liked'); like.setAttribute('aria-pressed', like.classList.contains('liked')); });
    const link = cfg.share || location.href;
    $('share').addEventListener('click', () => {
      if (navigator.share) { navigator.share({ url: link, title: 'ELLE EXISTE' }).catch(() => {}); return; }
      try { navigator.clipboard.writeText(link).then(() => say(D.copied || 'Link copied'), () => say(link)); } catch (e) { say(link); }
    });
  }
})();
